import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationBookingsTableBreadcrumbResolver {
  resolve(route: ActivatedRouteSnapshot): Observable<Breadcrumb[]> {
    return of([
      {
        label: '',
        url: route.routeConfig?.path?.split('/')[0] || '',
        translateLabel: 'organization.services.headline',
      },
    ]);
  }
}
